export default function initMenu() {
    $(".abre-menu").on("click", function () {
        $("#menu").addClass("show");
    });

    $(".close-menu").on("click", function () {
        $("#menu").removeClass("show");
    });

    $(".nav-sections").on("click", function () {
        var section = $(this).attr("href");
        $(".close-menu").click();

        if (section && $(section).length > 0) {
            $("html, body").animate(
                { scrollTop: $(section).offset().top },
                500
            );
        }
    });
}
